import { IncomeStatus } from "shared/types";
import { toMoney } from "shared/utils";
import { Stat } from "views/applications-id-report/components/Stat";
import { mapIncomeSourceStatus } from "views/applications-id-report/slices/CombinedIncomeReportSlice/helpers";
import { CombinedIncome } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/income";
import { VerifiedBankStatement } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified/bank-statment";
import {
  getIncomeActualNetAndGrossDollars,
  getMonthlyAmount,
  showValueOrPlaceholder
} from "views/applications-id-report/slices/CombinedIncomeReportSlice/utils";
import { ReverifyAttempt } from "../../../ReverifySlice/types";

export const IncomeStats = ({
  income,
  selectedReverifyAttempt,
  forcePlaceholdersDisplay,
  isIncomeIncomplete,
  bankStatements
}: {
  income: CombinedIncome;
  isIncomeIncomplete?: boolean;
  selectedReverifyAttempt?: ReverifyAttempt;
  forcePlaceholdersDisplay?: boolean;
  bankStatements?: Record<number, VerifiedBankStatement>;
}) => {
  const { status } = mapIncomeSourceStatus(income, bankStatements);
  const isRejected = status === "Rejected";
  const isProcessing = [IncomeStatus.Processing, IncomeStatus.Pending].includes(
    income.status
  );
  const { actualVerifiedNetMonthlyDollars, actualVerifiedGrossMonthlyDollars } =
    !isIncomeIncomplete
      ? getIncomeActualNetAndGrossDollars(
          income as CombinedIncome,
          selectedReverifyAttempt
        )
      : {};

  const selfReportedIncomeCents = income.amount_cents ?? 0;

  return (
    <div className="flex items-start">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 flex-1">
        <Stat
          title="Verified gross monthly"
          value={showValueOrPlaceholder(
            toMoney(actualVerifiedGrossMonthlyDollars ?? 0),
            !(
              forcePlaceholdersDisplay ||
              (isRejected && !actualVerifiedGrossMonthlyDollars) ||
              isProcessing
            )
          )}
        />
        <Stat
          title="Verified net monthly"
          value={showValueOrPlaceholder(
            toMoney(actualVerifiedNetMonthlyDollars ?? 0),
            !(
              forcePlaceholdersDisplay ||
              (isRejected && !actualVerifiedNetMonthlyDollars) ||
              isProcessing
            )
          )}
        />
        <Stat
          title="Self-reported gross monthly"
          value={showValueOrPlaceholder(
            toMoney(
              getMonthlyAmount(
                selfReportedIncomeCents ?? 0,
                income.pay_period
              ) / 100
            ),
            !forcePlaceholdersDisplay
          )}
        />
      </div>
    </div>
  );
};
